<template>
  <Teleport to="body">
    <Transition name="app-transition-fade">
      <div
        v-if="show"
        :class="['app-transition-overlay', `app-transition-${type}`, 'app-transition-overlay--glass']"
        role="status"
        aria-live="polite"
        aria-busy="true"
      >
        <div class="app-transition-backdrop" aria-hidden="true" />

        <div class="app-transition-panel">
          <div class="app-transition-icon-wrap">
            <span
              class="app-transition-icon-ring"
              :class="`app-transition-icon-ring--${type}`"
              aria-hidden="true"
            />
            <span class="app-transition-icon-badge" :class="`app-transition-icon-badge--${type}`" aria-hidden="true">
              <svg
                v-if="isSuccessType"
                class="app-transition-check-svg"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  stroke-width="2"
                  class="app-transition-check-circle"
                />
                <path
                  d="M8 12l2 2 4-4"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="app-transition-check-mark"
                />
              </svg>
              <i v-else :class="typeIconClass" />
            </span>
          </div>

          <h2 class="app-transition-title app-transition-title--glass">{{ title }}</h2>
          <p v-if="message" class="app-transition-message app-transition-message--glass">{{ message }}</p>
          <p v-if="submessage" class="app-transition-submessage app-transition-submessage--glass">{{ submessage }}</p>

          <div class="app-transition-progress app-transition-progress--glass">
            <div
              class="app-transition-progress-bar app-transition-progress-bar--glass"
              :class="`app-transition-progress-bar--${type}`"
            />
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script>
import './AppTransition.css';

const TYPE_ICONS = {
  logout: 'bi bi-box-arrow-right',
  loading: 'bi bi-hourglass-split',
  company: 'bi bi-building',
  companies: 'bi bi-buildings',
};

export default {
  name: 'AppTransition',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'loading',
      validator: (value) =>
        ['loading', 'login-success', 'signup-success', 'logout', 'company', 'companies'].includes(value),
    },
    title: {
      type: String,
      default: 'Loading...',
    },
    message: {
      type: String,
      default: '',
    },
    submessage: {
      type: String,
      default: '',
    },
  },
  computed: {
    isSuccessType() {
      return this.type === 'login-success' || this.type === 'signup-success';
    },
    typeIconClass() {
      return TYPE_ICONS[this.type] || 'bi bi-arrow-repeat';
    },
  },
  watch: {
    show(isOpen) {
      if (typeof document === 'undefined') return;
      document.body.style.overflow = isOpen ? 'hidden' : '';
    },
  },
  beforeUnmount() {
    if (typeof document !== 'undefined') {
      document.body.style.overflow = '';
    }
  },
};
</script>
